/**
 * Defines the `<custom-link>` custom element.
 * Evaluates the `data-link` attribute of its child button on click, enabling
 * Liquid-authored dynamic navigation or action strings to be executed client-side.
 */
if (!customElements.get('custom-link')) {

  class ComponentCustomLink extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button')
      this.init()
    }
    init() {
      if (!this.button) return;
      this.button.addEventListener('click', event => {
        event.preventDefault()
        eval(event.currentTarget.dataset.link)
      })
    }
  }
   customElements.define('custom-link', ComponentCustomLink);
}
